import { Mail, MapPin, TrendingUp } from 'lucide-react';
import { CookiePreferences } from './CookiePreferences';
import { ComplianceNotice } from './LegalNotices';
import { CONTACT_EMAIL, PRIVACY_PATH } from '../content/legal';

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="bg-gray-900 px-6 py-12 text-gray-300">
    <div className="container mx-auto max-w-6xl">
      <div className="mb-8 grid gap-8 md:grid-cols-4">
        <div>
          <a data-testid="footer-home-link" href="/" className="mb-4 flex items-center gap-2">
            <TrendingUp aria-hidden="true" className="h-6 w-6 text-[#7c4a97]" />
            <span className="text-xl font-bold text-white">GenMoney</span>
          </a>
          <p className="text-sm">Transforming financial wellbeing across UK organisations.</p>
        </div>
        <div>
          <h2 className="mb-4 text-base font-semibold text-white">Solutions</h2>
          <ul className="space-y-2 text-sm">
            {[['employers', 'solutions', 'For Employers'], ['universities', 'solutions', 'For Universities'], ['approach', 'features', 'Our Approach']].map(([id, hash, label]) => (
              <li key={id}><a data-testid={`footer-${id}-link`} href={`/#${hash}`} className="transition-colors hover:text-white">{label}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="mb-4 text-base font-semibold text-white">Company</h2>
          <ul className="space-y-2 text-sm">
            {[['testimonials', 'Testimonials'], ['faq', 'FAQ'], ['contact', 'Contact']].map(([id, label]) => (
              <li key={id}><a data-testid={`footer-${id}-link`} href={`/#${id}`} className="transition-colors hover:text-white">{label}</a></li>
            ))}
            <li><a data-testid="footer-privacy-link" href={PRIVACY_PATH} className="underline underline-offset-4 hover:text-white">Privacy Notice</a></li>
          </ul>
        </div>
        <div>
          <h2 className="mb-4 text-base font-semibold text-white">Contact Info</h2>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Mail aria-hidden="true" className="h-4 w-4 shrink-0 text-[#7c4a97]" /><a data-testid="footer-email-link" href={`mailto:${CONTACT_EMAIL}`} className="break-all hover:text-white">{CONTACT_EMAIL}</a></li>
            <li data-testid="footer-address" className="flex items-start gap-2"><MapPin aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-[#7c4a97]" /><span>124 City Road, London, EC1V 2NX</span></li>
          </ul>
        </div>
      </div>
      <div className="border-y border-gray-700 py-6">
        <ComplianceNotice testId="footer-compliance-notice" className="text-gray-100" />
      </div>
      <div className="pt-6 text-center text-sm">
        <p>GenMoney. All rights reserved.</p>
        <div className="mt-3"><CookiePreferences /></div>
      </div>
    </div>
  </footer>
);